import { Plus, Check } from 'lucide-react';
import { useCart } from '@/contexts/CartContext';
import { useLocale } from '@/contexts/LocaleContext';
import { toast } from 'sonner';

interface Props {
  activityId: string;
  className?: string;
  size?: 'sm' | 'md';
}

export function AddToCartButton({ activityId, className = '', size = 'md' }: Props) {
  const { addItem, isInCart } = useCart();
  const { locale } = useLocale();
  const isArabic = locale === 'ar';
  const inCart = isInCart(activityId);

  const sizeClasses = size === 'sm' ? 'w-8 h-8' : 'w-9 h-9';
  const iconSize = size === 'sm' ? 'w-6 h-6' : 'w-7 h-7';

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (inCart) {
      toast.info(isArabic ? 'موجود في السلة' : 'Already in basket');
      return;
    }
    addItem(activityId);
    toast.success(isArabic ? 'أُضيف إلى السلة ✅' : 'Added to basket ✅', {
      description: isArabic ? 'راجع السلة قبل إتمام الدفع' : 'Review your basket before checkout',
      action: {
        label: isArabic ? 'عرض السلة' : 'View basket',
        onClick: () => { window.location.href = '/basket'; },
      },
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={isArabic ? 'إضافة إلى السلة' : 'Add to basket'}
      className={`${sizeClasses} flex items-center justify-center transition-all hover:scale-110 ${className}`}
    >
      {inCart ? (
        <Check
          strokeWidth={2.5}
          className={`${iconSize} text-emerald-400 drop-shadow-md`}
        />
      ) : (
        <Plus
          strokeWidth={2.5}
          className={`${iconSize} text-white drop-shadow-md`}
        />
      )}
    </button>
  );
}
